<template>
  <div class="shareRegister" :style="conH">
    <van-row class="user-recommender">
      <span class="recommender"
        >邀请人：<span class="user">{{
          aMobile.substring(0, 3) + "****" + aMobile.substring(7)
        }}</span></span
      >
    </van-row>
    <van-row class="user-links">
      <van-col class="select">
        <div @click="changeArea">{{ selectedVal }}</div>
        <span class="triangle" :class="{ triangleL: triangleL }"></span>
      </van-col>

      <van-cell-group>
        <span class="tip"
          ><img
            src="../../assets/register/alert@2x.png"
          />密码必须是6-20个英文字母、数字(除空格),且字母、数字至少包含两种,区分大小写字母</span
        >
        <van-field
          class="mobile"
          v-model="phone"
          @input="blur"
          placeholder="请输入手机号"
          type="number"
          onkeyup="this.value=this.value.replace(/\D/g,'')"
          onafterpaste="this.value=this.value.replace(/\D/g,'')"
          maxlength="12"
        />
        <van-field
          v-model="msg"
          @input="blur"
          placeholder="请输入短信验证码"
          onkeyup="this.value=this.value.replace(/\D/g,'')"
          onafterpaste="this.value=this.value.replace(/\D/g,'')"
        >
          <van-button
            slot="button"
            size="small"
            @click="getvarify"
            v-if="downcounttime == 0"
            >获取验证码</van-button
          >
          <van-button
            class="downcount"
            slot="button"
            size="small"
            v-if="downcounttime == 1"
            >{{ down }}s后获取</van-button
          >
        </van-field>
        <van-field
          v-model="password"
          @input="blur"
          :type="type"
          placeholder="请输入密码"
          onkeyup="value=value.replace(/[^\w]/ig,'')"
          onafterpaste="this.value=this.value.replace(/[^\w]/ig,'')"
          maxlength="20"
        />
        <van-field
          v-model="repassword"
          @input="blur"
          :type="type"
          placeholder="请再次输入密码"
          onkeyup="value=value.replace(/[^\w]/ig,'')"
          onafterpaste="this.value=this.value.replace(/[^\w]/ig,'')"
          maxlength="20"
        />
        <van-switch-cell
          v-model="checked"
          @input="onInput"
          active-color="#F3816F"
          title="显示密码"
        />
        <van-button class="submit" size="large" v-if="open == 0"
          >立即注册</van-button
        >
        <van-button
          class="submit show"
          size="large"
          @click="register"
          v-if="open == 1"
          >立即注册</van-button
        >
        <span class="tip aggrement">
          <img
            v-if="select == 0"
            @click="changeSelect"
            src="../../assets/register/select@2x.png"
          />
          <img
            v-if="select == 1"
            @click="changeSelect"
            src="../../assets/register/selected@2x.png"
          />
          已阅读并同意以下协议<a href="/aggrement?number=1&from=0"
            >《销巴生活用户协议》</a
          ></span
        >
      </van-cell-group>
    </van-row>

    <van-popup v-model="spacePop" position="bottom" :overlay="true">
      <van-area
        :area-list="areaList"
        :columns-num="1"
        @confirm="confirm"
        @cancel="close"
      />
    </van-popup>
    <!-- 返回 -->
    <img
      class="shareRegisterBack"
      @click="prev()"
      src="./../../assets/school/back.png"
      alt=""
    />
    <!-- 注册成功引导页 -->
    <van-popup
      v-model="shareRegisterPopup"
      :round="true"
      :close-on-click-overlay="false"
    >
      <div class="shareRegisterPopup">
        <p class="shareRegisterPopupTitle">注册成功</p>
        <p class="shareRegisterPopupConten">
          恭喜你，注册成功！马上前往销巴生活体验消费增值乐趣。
        </p>
        <div class="sfBtmPopupButton">
          <span @click="shareRegisterPopupCancel()">返回</span>
          <span @click="shareRegisterPopupConfim()">前往APP</span>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
export default {
  data() {
    return {
      phone: "", //被邀请人电话
      phone_par: "", //电话加区号
      msg: "", //验证码
      password: "", //密码
      repassword: "",
      phontCorrect: 0,
      type: "password",
      label: "显示密码",
      checked: false, //是否显示密码
      select: 0, //是否同意协议
      open: 0,
      triangleL: false,
      selected: "",
      selectedVal: "",
      down: 60,
      downcounttime: 0,
      spacePop: false,
      aMobile: "", //邀请人手机号
      getVerifyNum: 0,
      stopGet: "",
      areaList: {
        province_list: {
          1: "中国大陆+86",
          2: "香港+852",
          3: "澳门+853",
          4: "台湾+886",
        },
      },
      flag: 0,
      conH: {},
      shareRegisterPopup: false,
      isiOS: false,
    };
  },
  created() {
    this.conH = { height: document.body.clientHeight + "px" };
    this.handleInput(); //如果没有这句代码，select中初始化会是空白的，默认选中就无法实现
    this.selectedVal = "+86";
    this.selected = 1;
    // 邀请人手机号
    this.aMobile = this.$route.query.aMobile;
    let ua = navigator.userAgent.toLowerCase();
    if (/iphone|ipad|ipod|macintosh/i.test(ua)) {
      this.isiOS = true;
    } else {
      this.isiOS = false;
    }
  },
  methods: {
    // 返回
    prev() {
      this.$router.go(-1);
    },
    changeArea() {
      this.phone = "";
      this.spacePop = !this.spacePop;
    },
    confirm(e) {
      this.selected = e[0].code;
      if (this.selected == 1) {
        this.selectedVal = "+86";
        this.triangleL = false;
      } else if (this.selected == 2) {
        this.selectedVal = "+852";
        this.triangleL = true;
      } else if (this.selected == 3) {
        this.selectedVal = "+853";
        this.triangleL = true;
      } else if (this.selected == 4) {
        this.selectedVal = "+886";
        this.triangleL = true;
      }
      this.spacePop = !this.spacePop;
    },
    close() {
      this.spacePop = false;
    },
    changeSelect() {
      this.select = !this.select;
      this.verification();
    },
    blur() {
      this.verification();
    },
    verification() {
      if (
        this.phone != "" &&
        this.msg != "" &&
        this.password != "" &&
        this.repassword != "" &&
        this.select != 0
      ) {
        this.open = 1;
      } else {
        this.open = 0;
      }
    },
    onInput(checked) {
      this.checked = checked;
      if (this.type == "password") {
        this.type = "text";
      } else {
        this.type = "password";
      }
    },
    verigyPhone() {
      if (this.phone == "") {
        this.$toast("请输入手机号");
      } else {
        if (this.selected == 1) {
          //大陆手机号 第一位是1，第二位不能是1或2,长度11 ^1[3456789]\d{9}$
          if (/^1\d{10}$/.test(this.phone)) {
            this.phone_par = this.phone;
            this.phontCorrect = 1;
          } else {
            this.$toast("手机号格式错误");
            return false;
          }
        } else if (this.selected == 2) {
          //香港手机号852 第一位必须是6或9，长度8
          if (/^\d{8}$/.test(this.phone)) {
            this.phone_par = "852" + this.phone;
            this.phontCorrect = 1;
          } else {
            this.$toast("手机号格式错误");
            return false;
          }
        } else if (this.selected == 3) {
          //澳门手机号853 第一位必须是6，长度8
          if (/^\d{8}$/.test(this.phone)) {
            this.phone_par = "853" + this.phone;
            this.phontCorrect = 1;
          } else {
            this.$toast("手机号格式错误");
            return false;
          }
        } else if (this.selected == 4) {
          //台湾手机号886 第一位必须是9，长度9
          if (/^\d{9}$/.test(this.phone)) {
            this.phone_par = "886" + this.phone;
            this.phontCorrect = 1;
          } else {
            this.$toast("手机号格式错误");
            return false;
          }
        }
      }
    },
    getvarify() {
      this.phontCorrect = 0;
      if (this.getVerifyNum < 5) {
        this.getVerifyNum++;
        this.verigyPhone();
        const _this = this;
        if (this.phontCorrect == 1) {
          this.$api
            .post("member/index/member/phone/check", { phone: this.phone_par })
            .then(() => {
              this.$api
                .post("/pushmsg/index/sms/send-code", {
                  mobile: this.phone_par,
                  type: 0,
                })
                .then((res) => {
                  _this.down = 60;
                  const timer = setInterval(function () {
                    _this.down--;
                    _this.downcounttime = 1;
                    if (_this.down <= 0) {
                      clearInterval(timer);
                      _this.downcounttime = 0;
                    }
                  }, 1000);
                  _this.$toast("验证码已发送，请注意查收");
                })
                .catch((err) => {
                  let keys = Object.keys(err);
                  let key = keys[0];
                  let message = err.message || err[key][0];
                  //this.$toast(message);
                  if (message.slice(0, 10) == "timeout of") {
                    this.$toast("网络不给力，请稍候重试");
                  } else {
                    this.$toast(message);
                  }
                });
            })
            .catch((err) => {
              let keys = Object.keys(err);
              let key = keys[0];
              let message = err.message || err[key][0];
              _this.$toast(message);
            });
        }
      } else {
        var current = Math.floor(new Date().getTime() / 1000);
        var tip = "";
        if (this.getVerifyNum == 5) {
          this.getVerifyNum++;
          this.stopGet = current + 60 * 15;
          //        this.$toast('获取验证码次数已超过5次，请过15分钟之后再试。')
        }
        var ts = this.stopGet - current;
        var mm = Math.floor(ts / 60);
        var ss = ts - mm * 60;
        if (mm && ss) {
          tip =
            "获取验证码次数已超过5次，请过" + mm + "分钟" + ss + "秒之后再试。";
        } else if (mm && !ss) {
          tip = "获取验证码次数已超过5次，请过" + mm + "分钟之后再试。";
        } else if (!mm && ss) {
          tip = "获取验证码次数已超过5次，请过" + ss + "秒之后再试。";
        }

        this.$toast(tip);
      }
    },
    register() {
      this.phontCorrect = 0;
      //此事件触发前提为：所有信息均填写且用户已同意先把生活服务条款
      this.verigyPhone();
      if (this.phontCorrect == 1) {
        //手机号正确 下一步验证 密码格式
        if (
          /(?!^\d+$)(?!^[A-Za-z]+$)(?!^[^A-Za-z0-9]+$)^\S{6,20}$/.test(
            this.password
          )
        ) {
          //密码格式正确 下一步验证 两次输入密码是否一致
          if (this.password == this.repassword) {
            //两次输入密码一致 下一步请求接口
            if (this.flag == 0) {
              this.flag = 1;
              // if (this.selected == 2) {
              //   this.phone_par = "852" + this.phone;
              // } else if (this.selected == 3) {
              //   this.phone_par = "853" + this.phone;
              // } else if (this.selected == 4) {
              //   this.phone_par = "886" + this.phone;
              // }
              this.submit();
            }
          } else {
            this.$toast("再次输入密码的格式错误");
            return false;
          }
        } else {
          this.$toast("密码格式错误");
          return false;
        }
      }
    },
    submit() {
      this.$api
        .post("/school/index/share/register", {
          referrer_username: this.aMobile, //推荐人手机号
          username: this.phone_par, //注册手机号
          code: this.msg, //验证码
          password: this.password,
          password_confirmation: this.repassword,
        })
        .then((res) => {
          // 注册成功!
          this.shareRegisterPopup = true;
        })
        .catch((err) => {
          this.flag = 0;
          let keys = Object.keys(err);
          let key = keys[0];
          let message = err.message || err[key][0];
          //this.$toast(message);
          if (message.slice(0, 10) == "timeout of") {
            this.$toast("网络不给力，请稍候重试");
          } else {
            this.$toast(message);
          }
        });
    },
    shareRegisterPopupCancel() {
      this.shareRegisterPopup = false;
      this.prev();
    },
    shareRegisterPopupConfim() {
      // this.shareRegisterPopup = false;
      if (this.isiOS) {
        window.location.href =
          "http://itunes.apple.com/cn/app/id1273703378?ls=1&mt=8";
      } else {
        this.$router.push("/school/load");
      }
    },
    handleInput() {
      if (/Android/gi.test(navigator.userAgent)) {
        window.addEventListener("resize", function () {
          window.setTimeout(function () {
            document.activeElement.scrollIntoView(false);
          }, 1);
        });
      }
    },
  },
  mounted() {},
};
</script>

<style lang="less">
p {
  margin: 0;
}
.shareRegister {
  background: url(../../assets/register/bg@2x.png) no-repeat center center;
  background-size: 100% 100%;
  padding: 0 12px;
  height: 100%;
  .user {
    &-recommender {
      text-align: center;
      padding-top: 27%;
      padding-bottom: 20%;
      .recommender {
        width: 191px;
        height: 54px;
        color: #fe7a0e;
        font-size: 13px;
        line-height: 60px;
        display: inline-block;
        background: url(../../assets/register/Superior@2x.png) no-repeat center
          center;
        background-size: 100% 100%;
      }
    }
    &-links {
      padding: 12px 20px;
      font-size: 12px;
      text-align: center;
      background: url(../../assets/register/middlebg@2x.png) no-repeat center
        center;
      background-size: 100% 100%;
      position: relative;
      .select {
        position: absolute;
        top: 65px;
        left: 20px;
        z-index: 10;
        padding-left: 0;
        padding-top: 0;
        div {
          border: none;
          color: #555;
          font-size: 16px;
          -webkit-appearance: none;
          -webkit-tap-highlight-color: #fff;
          outline: 0;
          background: rgba(255, 255, 255, 0);
          margin-top: 0;
          margin-left: 0;
          padding-top: 0;
          padding-left: 0;
        }
        .triangle {
          position: absolute;
          top: 7px;
          left: 30px;
          z-index: 10;
          width: 0;
          height: 0;
          border-right: 4px solid transparent;
          border-left: 4px solid transparent;
          border-top: 6px solid #555;
        }
        .triangleL {
          left: 38px;
        }
        @media only screen and (min-width: 320px) and (max-width: 374px) {
          .triangle {
            left: 30px;
            top: 7px;
          }
          .triangleL {
            left: 38px;
          }
        }
      }

      .van-hairline--top-bottom::after {
        border-width: 0 0;
      }
      .van-cell-group {
        background: rgba(255, 255, 255, 0);
        .tip {
          text-align: left;
          color: #f96a0e;
          font-size: 14px;
          /*height: 20px;*/
          line-height: 20px;
          display: block;
          margin-bottom: 3px;
          img {
            width: 16px;
            float: left;
            margin: 2px 12px 0 0;
          }
        }
        .aggrement {
          color: #999;
          font-size: 12px;
          height: 36px;
          line-height: 36px;
          margin: 3px 0 0;
          img {
            width: 18px;
            margin: 9px 8px 0 0;
          }
          a {
            color: #999;
            font-size: 12px !important;
          }
          a:hover {
            color: #999;
            font-size: 12px;
          }
          a:active {
            color: #999;
            font-size: 12px;
          }
        }
        .van-cell {
          padding: 10px 0;
          background: rgba(255, 255, 255, 0);
          .van-button {
            color: #f3816f;
            border: none;
            font-size: 16px;
            height: 22px;
            line-height: 22px;
            padding-left: 20px;
            padding-right: 0;
            border-left: solid 1px #eee;
          }
          .downcount {
            color: #c0c0c0;
          }
          .van-button,
          .van-button:active {
            background: #fefceb;
          }
          .van-cell__title {
            text-align: left;
            color: #555;
            font-size: 16px;
          }
          .van-field__control {
            color: #333;
            font-size: 16px;
          }
          input::-webkit-input-placeholder {
            /* WebKit, Blink, Edge */
            color: #c0c0c0 !important;
          }
          input:-moz-placeholder {
            /* Mozilla Firefox 4 to 18 */
            color: #c0c0c0 !important;
          }
          input::-moz-placeholder {
            /* Mozilla Firefox 19+ */
            color: #c0c0c0 !important;
          }
          input:-ms-input-placeholder {
            /* Internet Explorer 10-11 */
            color: #c0c0c0 !important;
          }
          @media only screen and (min-width: 320px) and (max-width: 374px) {
            .van-cell__title,
            .van-button,
            .van-field__control {
              font-size: 13px;
            }
          }
        }
        .mobile {
          padding-left: 52px;
        }
        @media only screen and (min-width: 320px) and (max-width: 374px) {
          .mobile {
            padding-left: 48px;
          }
        }
        .submit {
          color: #fff;
          font-size: 16px;
          background: #e3e3e3;
          height: 44px;
          border: none;
          border-radius: 25px;
        }
        .show {
          background: -webkit-linear-gradient(
            #feac7a,
            #ff6059
          ); /* Safari 5.1 - 6.0 */
          background: -o-linear-gradient(
            #feac7a,
            #ff6059
          ); /* Opera 11.1 - 12.0 */
          background: -moz-linear-gradient(
            #feac7a,
            #ff6059
          ); /* Firefox 3.6 - 15 */
          background: linear-gradient(#feac7a, #ff6059);
        }
        .van-cell::after {
          content: " ";
          position: absolute;
          pointer-events: none;
          -webkit-box-sizing: border-box;
          box-sizing: border-box;
          left: 0px;
          right: 0;
          bottom: 0;
          /*-webkit-transform: scaleY(0.5);
	        transform: scaleY(0.5);*/
          border-bottom: 1px solid #ebedf0;
        }
        @media only screen and (min-width: 320px) and (max-width: 374px) {
          .tip {
            font-size: 12px;
            img {
              width: 14px;
              margin: 3px 8px 0 0;
            }
          }
          .aggrement {
            font-size: 8px !important;
            white-space: nowrap;
            img {
              width: 16px;
              margin: 11px 4px 0 0;
              margin-left: -3px;
            }
          }
          .submit {
            font-size: 14px;
            height: 38px;
            line-height: 38px;
          }
        }
      }
    }
    @media only screen and (min-width: 320px) and (max-width: 374px) {
      &-recommender {
        padding-bottom: 17%;
      }
      &-links {
        select {
          font-size: 13px;
          top: 69px;
        }
      }
    }
  }
  .van-popup--bottom {
    /*border-top-left-radius: 14px;
	  border-top-right-radius: 14px;*/
    height: auto;
    .van-picker__cancel {
      color: #999;
      font-size: 17px;
    }
    .van-picker__confirm {
      color: #f3816f;
      font-size: 17px;
    }
    [class*="van-hairline"]::after {
      border-bottom: solid 1px #eeeeee;
    }
  }
  .shareRegisterBack {
    width: 32px;
    height: 32px;
    position: fixed;
    top: 15px;
    left: 12px;
  }
  .shareRegisterPopup {
    width: 216px;
    padding: 32px 32px 24px;
    display: flex;
    flex-direction: column;
    border-radius: 16px;
    .shareRegisterPopupTitle {
      font-size: 16px;
      font-weight: bolder;
      color: #404247;
      line-height: 22px;
      text-align: center;
      margin: 0px 0 24px;
    }
    .shareRegisterPopupConten {
      font-size: 14px;
      font-weight: 400;
      color: #6e727a;
      line-height: 20px;
    }
    .sfBtmPopupButton {
      margin-top: 24px;
      display: flex;
      justify-content: space-between;
      span {
        width: 100px;
        height: 38px;
        border-radius: 18px;
        font-size: 13px;
        font-weight: 500;
        color: #ffffff;
        display: flex;
        align-items: center;
        justify-content: center;
      }
      span:first-child {
        background-color: rgba(78, 125, 247, 0.1);
        color: #4e7df7;
      }
      span:last-child {
        background-color: #4e7df7;
      }
    }
  }
}
</style>
